<template>
  <div class="rereadUpImg">
    <div class="uploadImgBox">
      <van-image
        class="listImg"
        v-for="(item, index) in fileList"
        :key="index"
        :src="item"
        fit="cover"
        @click="previewImage(index)"
      >
        <img
          v-if="showDelete"
          class="closeIcon"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/agreement/del.png"
          alt="close"
          @click.stop="delImage(index)"
        >
      </van-image>
      <template v-if="$root.isApp">
        <div
          class="cameraBox"
          @click="arouse"
          v-show="fileList.length < maxNum"
        >
          <div>
            <img
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/agreement/Takepictures.png"
              alt=""
            >
            <span>上传图片</span>
          </div>
        </div>

      </template>
      <template v-else>
        <van-uploader
          v-show="fileList.length < maxNum"
          :after-read="afterRead"
          :preview-image="false"
        >
          <div class="cameraBox">
            <div v-if="loading">
              <van-loading size="24px" vertical>图片上传中...</van-loading>
            </div>
            <div v-else>
              <img
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/agreement/Takepictures.png"
                alt=""
              >
              <span>上传图片</span>
            </div>
          </div>
        </van-uploader>
      </template>
      <div v-if="showPreviewExample" class="example" @click="previewExample">示例</div>
    </div>

    <van-image-preview
      v-model="isShowPreview"
      :images="fileList"
      :startPosition="startPosition"
      get-container="body"
    />

    <van-image-preview
      v-model="isShowExamplePreview"
      :images="defaultExampleList"
      startPosition="0"
      get-container="body"
    />
  </div>
</template>

<script>
import { ADMIN_URL,isOhos } from '@/utils/common';

import axios from 'axios';

export default {
  components: {
  },
  props: {
    maxNum: {
      type: Number,
      default: 9,
    },
    fileList: {
      type: Array,
      default: () => [],
    },
    showPreviewExample: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      action: `${ADMIN_URL}/ref/v1/oss/file?type=image`,
      isShowPreview: false, // 是否开启预览
      startPosition: 0, // 预览索引
      isShowExamplePreview: false,
      defaultExampleList: [`${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/bilibiliShipments/%E7%BC%96%E7%BB%84%2018%402x.png`],
      loading: false,
    };
  },
  methods: {
    arouse() {
      if (this.$root.$data.isApp) {
        window.uploaderFiles = (value) => {
          const data = isOhos ? value : JSON.parse(value);
          if (data.success !== 1) {
            this.$toast.fail('上传失败');
          } else {
            this.fileList = [...this.fileList, ...data.images];
            this.$emit('getListFile', this.fileList);
          }
        };

        this.$sendToApp('arouseImagePicker', { pickNum: 1 });
      }
    },
    previewImage(index) {
      // 图片预览
      this.isShowPreview = true;
      this.startPosition = index;
    },
    previewExample() {
      this.isShowExamplePreview = true;
    },
    delImage(index) {
      // 删除图片
      this.fileList.splice(index, 1);
      this.$emit('getListFile', this.fileList);
    },

    afterRead(file) {
      this.loading = true;
      const path = `${ADMIN_URL}/ref/v1/oss/file?type=image`;
      const formData = new FormData();
      formData.append('file', file.file);
      axios({
        url: path,
        method: 'POST',
        data: formData,
        processData: false, // 告诉axios不要去处理发送的数据(重要参数)
        contentType: false, // 告诉axios不要去设置Content-Type请求头
      }).then((res) => {
        if (res.data.code === 0) {
          this.fileList.push(res.data.data);
          this.$emit('getListFile', this.fileList);
        } else {
          this.$toast.fail('上传失败');
        }
        this.loading = false;
      });
    },
  },

};
</script>

<style scoped lang="scss">
.rereadUpImg {
  .uploadImgBox {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 22px;
    .cameraBox {
      width: 187px;
      height: 187px;
      background: #f5f6f7;
      border-radius: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      img {
        width: 56px;
        height: 45px;
      }
      span {
        display: block;
        font-size: 22px;
        font-weight: 400;
        color: #666666;
        line-height: 31px;
      }
    }
    .listImg {
      position: relative;
      width: 187px;
      height: 187px;
      ::v-deep .van-image__img {
        border-radius: 14px;
      }
      .closeIcon {
        position: absolute;
        top: -8px;
        right: -8px;
        width: 29px;
        height: 29px;
      }
    }
  }

  .example {
    margin: 78px 0 78px 22px;
    font-size: 22px;
    color: #FF3938;
  }
}
</style>
